import { HomePage as Home } from "./home.page";
export default Home;
